__turbopack_context__.v({
  "contentWrapper": "GuaranteeModal-module__aGCxFq__contentWrapper",
  "guaranteesList": "GuaranteeModal-module__aGCxFq__guaranteesList",
});
